<template>
  <div class="container">
    <div class="row text-center">
        <div class="col-md-12">
            <img src="@/assets/404.png" class="img-fluid" alt="Error404">
            <h1>Whoops, 404</h1>
            <h3>The page you were looking for does not exist.</h3>
            <div class="mt-3 animate__animated animate__backInLeft">
                <router-link to="/">
                    <button class="btn btn-primary">
                        Back to Home page
                    </button>
                </router-link>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
    name : "Error404Page",
}
</script>

<style>

</style>